import classNames from "classnames";
import styles from "./AscRadioButton.module.scss";

export interface AscRadioButtonProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  variant?: "primary" | "secondary";
}

export default function AscRadioButton({
  className,
  variant = "primary",
  ...rest
}: AscRadioButtonProps) {
  return (
    <input
      className={classNames(
        styles.ground,
        {
          [styles.primary]: variant === "primary",
          [styles.secondary]: variant === "secondary",
        },
        className
      )}
      {...rest}
      type="radio"
    />
  );
}
